import { isNull, isUndefined } from 'lodash';

export const isNullOrUndefined = (value: unknown): value is null | undefined => isNull(value) || isUndefined(value);

export const isNotNullOrUndefined = <T>(value: T | undefined | null): value is T => !isNullOrUndefined(value);

/** Returns path and query string of `url` if it points to the origin of `baseUrl` (relative urls included), else undefined. */
export const getRouteIfSameOrigin = (url: string, baseUrl: string): string | undefined => {
  try {
    const parsed = new URL(url, baseUrl);
    return parsed.origin === new URL(baseUrl).origin ? `${parsed.pathname}${parsed.search}` : undefined;
  } catch {
    return undefined;
  }
};

export const isStringNotBlank = (value?: string | undefined | null): value is string =>
  isNotNullOrUndefined(value) && value.trim().length > 0;

export function assertNotNullOrUndefined<T>(
  value: T | undefined | null,
  message = 'Expected value to not be null or undefined',
): asserts value is T {
  if (isNullOrUndefined(value)) {
    throw new Error(message);
  }
}

export const getBrMasterNumberForDisplay = (brMaster: string | undefined) => {
  if (isNullOrUndefined(brMaster) || brMaster === '-') return '-';
  return `${brMaster.slice(0, 4)}.${brMaster.slice(4)}`;
};

export const constructMailto = (emailAddress: string, subject?: string, body?: string) => {
  const params: string[] = [];

  if (subject) {
    params.push(`subject=${encodeURIComponent(subject)}`);
  }

  if (body) {
    params.push(`body=${encodeURIComponent(body)}`);
  }

  const queryString = params.join('&');

  const suffix = queryString ? '?' + queryString : '';
  globalThis.location.href = `mailto:${emailAddress}${suffix}`;
};

export const removeSearchParams = (path: string): string => {
  return path.split('?')[0];
};
